import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/react/react/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import data from '../../packages/react/src/Heading/Heading.docs.json';
import DeprecationBanner from '../components/DeprecationBanner';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const ComponentProps = makeShortcode("ComponentProps");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <DeprecationBanner replacementUrl={'/components/heading/react/latest'} mdxType="DeprecationBanner" />
    <p>{`The Heading component will render an html `}<inlineCode parentName="p">{`h2`}</inlineCode>{` tag without any default styling. Other heading level elements `}<inlineCode parentName="p">{`h1-h6`}</inlineCode>{` are available through use of the `}<inlineCode parentName="p">{`as`}</inlineCode>{` prop (see `}<a parentName="p" {...{
        "href": "/system-props"
      }}>{`System Props`}</a>{` for additional explanation). Please reference the `}<a parentName="p" {...{
        "href": "https://www.w3.org/WAI/tutorials/page-structure/headings/"
      }}>{`w3 recommendations for headings`}</a>{` to ensure your headings provide an accessible experience for screen reader users.`}</p>
    <p><strong parentName="p">{`Attention:`}</strong>{` Make sure to include a valid heading element to render a Heading component other than `}<inlineCode parentName="p">{`h2`}</inlineCode>{` (`}<inlineCode parentName="p">{`<Heading as="h1">H1 Element</Heading>`}</inlineCode>{`).`}</p>
    <h2>{`Example`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Heading sx={{fontSize: 1, mb: 2}}>H2 heading with fontSize={1}</Heading>
`}</code></pre>
    <h2>{`Props`}</h2>
    <ComponentProps data={data} mdxType="ComponentProps" />
    <h2>{`Status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: true,
      noUnnecessaryDeps: true,
      adaptsToThemes: true,
      adaptsToScreenSizes: false,
      fullTestCoverage: true,
      usedInProduction: false,
      usageExamplesDocumented: true,
      designReviewed: false,
      a11yReviewed: false,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: false,
      hasFigmaComponent: false
    }} mdxType="ComponentChecklist" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      